<section class="operations-page">
    <div class="operations-page__card" *ngIf="visionConfig.loading$ | async; else content">
        <p class="operations-page__loading">Loading vision configuration…</p>
    </div>

    <ng-template #content>
        <div class="operations-page__card">
            <header class="operations-page__header">
                <div>
                    <h2 class="operations-page__title">Operations Center</h2>
                    <p class="operations-page__lead">
                        Summarized operational health for vehicle transaction lifecycle monitoring.
                        Vehicle Transactions is the primary monitoring screen; Provider Events shows raw ingestion
                        detail.
                    </p>
                </div>
            </header>

            <p class="operations-page__loading operations-home__metrics-loading" *ngIf="metricsLoading">
                Loading operational metrics…
            </p>

            <dl class="operations-home__stats" *ngIf="!metricsLoading">
                <button type="button" class="operations-home__stat operations-home__stat--link"
                        (click)="navigateToTransactions('completed')">
                    <dt>Completed</dt>
                    <dd>{{ metrics.completed }}</dd>
                </button>
                <button type="button" class="operations-home__stat operations-home__stat--link"
                        (click)="navigateToTransactions('waiting')">
                    <dt>Waiting</dt>
                    <dd>{{ metrics.waiting }}</dd>
                </button>
                <button type="button" class="operations-home__stat operations-home__stat--link"
                        (click)="navigateToTransactions('needs_attention')">
                    <dt>Needs Attention</dt>
                    <dd>{{ metrics.needsAttention }}</dd>
                </button>
                <button type="button" class="operations-home__stat operations-home__stat--link"
                        (click)="navigateToTransactions('failed')">
                    <dt>Failed</dt>
                    <dd>{{ metrics.failed }}</dd>
                </button>
                <div class="operations-home__stat operations-home__stat--wide">
                    <dt>Latest transaction activity</dt>
                    <dd>
                        <a *ngIf="metrics.latestTransaction as transaction"
                           class="operations-home__inline-link"
                           [routerLink]="['/operations/transactions', transaction.transaction_id]">
                            {{ latestTransactionActivityLabel(transaction) }}
                        </a>
                        <span *ngIf="!metrics.latestTransaction">{{ latestTransactionActivityLabel(null) }}</span>
                    </dd>
                </div>
            </dl>

            <dl class="operations-home__stats operations-home__stats--secondary"
                *ngIf="visionConfig.snapshot as context">
                <div class="operations-home__stat">
                    <dt>Vision mode</dt>
                    <dd>{{ visionModeLabel | titlecase }}</dd>
                </div>
                <div class="operations-home__stat">
                    <dt>Enabled analytics</dt>
                    <dd>{{ visionConfig.enabledAnalytics.length }}</dd>
                </div>
                <div class="operations-home__stat">
                    <dt>VTE pipeline</dt>
                    <dd>{{ context.vte_pipeline_enabled === false ? 'Disabled' : 'Enabled' }}</dd>
                </div>
            </dl>

            <div class="operations-home__links">
                <a class="operations-home__link" routerLink="/operations/transactions">Vehicle Transactions</a>
                <a class="operations-home__link" routerLink="/operations/provider-events">Provider Events</a>
            </div>
        </div>
    </ng-template>
</section>
